import { Box, Grid } from "@mui/material"
import { BigNumber } from "ethers"
import React, { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import Button from "src/components/Button"
import Text from "src/components/Text"
import TransactionSummary from "src/components/TransactionSummary"
import { XFER } from "src/constants"
import boostPools from "src/constants/boostPools"
import { formatNumber, getRawAmount } from "src/utils/parseStringToBigNumber"
import UpgradeDetails from "../UpgradeDetails"
import Warning from "../Warning"
import LockingPeriodSelect from "./LockingPeriodSelect"

interface SelectPeriodStepProps {
  currentPool: number
  amount: BigNumber
  onSelect: (selectedPool: number) => void
  selectedPool: number
  onConfirm: () => void
  lastUnlockTime: number
}

const SelectPeriodStep = ({
  currentPool,
  amount,
  onSelect,
  selectedPool,
  onConfirm,
  lastUnlockTime,
}: SelectPeriodStepProps) => {
  const { t } = useTranslation()
  const avaiablePeriods = useMemo(
    () => boostPools.filter((x) => x.pid > currentPool),
    [currentPool],
  )
  const selectedPoolInfo = boostPools.find((pool) => pool.pid === selectedPool)
  const formattedAmount = getRawAmount(amount, XFER.decimals)

  useEffect(() => {
    onSelect(avaiablePeriods[0].pid)
  }, [avaiablePeriods, onSelect])

  return (
    <Box>
      <Text>{t("Select a new locking period")}</Text>
      <Grid container mt={3} gap={1}>
        {avaiablePeriods.map((pool) => (
          <Grid item key={pool.pid} xs={12} sm>
            <LockingPeriodSelect
              {...pool}
              isSelected={selectedPoolInfo?.pid === pool.pid}
              onSelect={() => onSelect(pool.pid)}
            />
          </Grid>
        ))}
      </Grid>
      <UpgradeDetails
        currentPool={currentPool}
        selectedPool={selectedPool}
        lastUnlockTime={lastUnlockTime}
      />
      <TransactionSummary
        data={[
          {
            label: t("Lock"),
            amount: formatNumber(formattedAmount, 2, 6),
            token: XFER,
          },
        ]}
      />
      <Text maxWidth="468px" mt={3} mb={3}>
        {t(
          "This amount included unlocked xFER that you may withdraw. Upgrading the vault will lock this amount as well.",
        )}
      </Text>
      <Warning />
      <Button fullWidth onClick={onConfirm}>
        {t("Upgrade")}
      </Button>
    </Box>
  )
}

export default SelectPeriodStep
